<template>
  <base-card>
    <template v-slot:header>
      <base-card-heading>{{ heading }}</base-card-heading>
    </template>
    <template v-if="user.profile.relationshipManager">
      <contact-card
        :email="email"
        :name="name"
        :no-border="noBorder"
        :phone="phone"
        :role="'Relationship Manager'" />
    </template>
    <template v-else>
      No relationship manager has been assigned yet.
    </template>
  </base-card>
</template>

<script>
import ContactCard from './ContactCard.vue'

export default {
  name: 'UserRelationshipManager',

  components: {
    ContactCard
  },

  props: {
    heading: { default: 'Your Relationship Manager', type: String },
    noBorder: { default: false, type: Boolean },
    user: { required: true, type: Object }
  },

  computed: {
    email () {
      return this.manager.email
    },

    manager () {
      return this.user.profile.relationshipManager
    },

    name () {
      return `${this.manager.profile.firstName}  ${this.manager.profile.lastName}`
    },

    phone () {
      return this.manager.profile.phone
    }
  }
}
</script>
